import React from "react";
import PropTypes from "prop-types";

import { Carousel } from "../basic/full-screen-slider/full-screen-slider";
import { wrapCollectionLayout } from "@quintype/components";
import { isEager } from "../../utils";

function FullScreenSliderBase({
  collection,
  stories = [],
  associatedMetadata = {},
  metadata = {},
  config = {},
  index
}) {
  const slidesToShow = associatedMetadata["number_of_slides_to_show"]
    ? parseInt(associatedMetadata["number_of_slides_to_show"])
    : undefined;
  const eager = isEager(index, true);
  const carouselProps = Object.assign(
    {},
    { stories, config, metadata, collection },
    { associatedMetadata: associatedMetadata },
    metadata,
    {
      slidesToShow,
      eager
    }
  );

  return React.createElement(Carousel, carouselProps);
}

FullScreenSliderBase.propTypes = {
  collection: PropTypes.object,
  config: PropTypes.object,
  associatedMetadata: PropTypes.object,
  metadata: PropTypes.object,
  stories: PropTypes.array,
  index: PropTypes.number
};

export const FullImageSlider = wrapCollectionLayout(FullScreenSliderBase);
